import { ApiDef_AdvisorATS } from '@app/artifact-ats-shared/types';
import { Module } from '@nu-art/ts-common';
import { apiWithBody } from '@nu-art/thunderstorm-frontend/index';
export class ModuleFE_AdvisorATS_Class extends Module {
    api;
    constructor() {
        super();
        this.api = {
            createAdvisorArtifact: apiWithBody(ApiDef_AdvisorATS.api.createAdvisorArtifact),
        };
    }
}
export const ModuleFE_AdvisorATS = new ModuleFE_AdvisorATS_Class();
//# sourceMappingURL=ModuleFE_AdvisorATS.js.map